import { AutoAwesome, Lock } from "@mui/icons-material"
import { BoxCard, Button, Grid, IconWrapper, Typography } from "../../basics"
import { useDrawerStore, useRankingStore, useMessageStore } from "src/store"
import { CARD_WIDTH } from "../../../consts/cardSize"

const RankingCard = (props: any) => {
    const openDrawer = useDrawerStore((s: any) => s.openDrawer)
    const setRankings = useRankingStore((s: any) => s.setRankings)
    const setActualContext = useMessageStore((s: any) => s.setActualContext)
    const setJsonContext = useMessageStore((s: any) => s.setJsonContext)

    const locked = props.locked === true

    const handleEditRanking = () => {
        if (locked) return
        if (props.rankings) {
            setRankings(props.rankings, props.asset, props.assetKey)
        }
        setActualContext(`Editar rankings em ${props.asset}`)
        setJsonContext(undefined)
        openDrawer()
    }

    return (
        <BoxCard sx={{ width: CARD_WIDTH, maxWidth: CARD_WIDTH, opacity: locked ? 0.85 : 1, position: "relative", height: "100%", display: "flex", flexDirection: "column" }}>
            {locked && (
                <Lock
                    sx={{ position: "absolute", top: 12, right: 12, fontSize: 18 }}
                    color="action"
                />
            )}
            <Grid sx={{ display: "flex", flexDirection: "column", flex: 1, width: "100%" }}>
                <Grid container justifyContent="space-between" wrap="nowrap" sx={{ pr: locked ? 3 : 0 }}>
                    <Typography variant="h4">
                        {props.asset}
                    </Typography>
                    <Typography variant="body2">
                        {props.date}
                    </Typography>
                </Grid>
                <Grid sx={{ flexGrow: 1, mt: 1 }}>
                    <Typography>
                        {props.description}
                    </Typography>
                </Grid>
                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleEditRanking}
                        disabled={locked}
                    >
                        <Grid justifyContent="center" alignContent="center">
                            <Grid container gap={2}>
                                <IconWrapper color="neutral">
                                    {locked ? <Lock /> : <AutoAwesome />}
                                </IconWrapper>
                                <Typography variant="h4">
                                    {locked ? "Ranking bloqueado" : "Editar ranking"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Button>
                </Grid>
            </Grid>
        </BoxCard>
    )
}

export {RankingCard}